// extracted by mini-css-extract-plugin
export default {"generationFinishPage":"FluxUltraFinishPage_generationFinishPage__lwihv","container":"FluxUltraFinishPage_container__wVeyJ"};